import { Trash } from "iconsax-react";
import React from "react";
import * as RB from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function DynamicTables({
  invoice,
  setinvoice,
  docBooking,
  setdocBooking,
  isDisable,
}) {
  const handleInputChange = (index, field, value) => {
    if (field === "qty" && !/^\d*$/.test(value)) {
      return;
    }

    if (field === "value" && !/^\d*\.?\d{0,2}$/.test(value)) {
      return;
    }

    const updatedRows = [...invoice];
    updatedRows[index][field] = value;
    setinvoice(updatedRows);
  };

  const addRow = () => {
    setinvoice([
      ...invoice,
      { supplierName: "", billNo: "", date: null, qty: "", value: "" },
    ]);
  };

  const removeRow = (index) => {
    setinvoice(invoice.filter((_, rowIndex) => rowIndex !== index));
  };

  const handleDocInputChange = (index, field, value) => {
    if (["igst", "sgst", "cgst"].includes(field)) {
      const numericValue = parseFloat(value);

      if (
        !/^\d*\.?\d*$/.test(value) ||
        numericValue < 1 ||
        numericValue > 100
      ) {
        return;
      }
    }

    if (field === "capValue" && !/^\d*\.?\d{0,2}$/.test(value)) {
      return;
    }

    const updatedRows = [...docBooking];
    updatedRows[index][field] = value;
    setdocBooking(updatedRows);
  };

  const addDocRow = () => {
    setdocBooking([
      ...docBooking,
      {
        no: "",
        date: "",
        itemDesc: "",
        basic: "",
        bedAdhoc: "",
        igst: "",
        sgst: "",
        cgst: "",
        capValue: "",
      },
    ]);
  };

  const removeDocRow = (index) => {
    setdocBooking(docBooking.filter((_, rowIndex) => rowIndex !== index));
  };

  return (
    <>
      <div className="mt-3 table-responsive">
        <h5>Invoice Details</h5>
        <RB.Table bordered>
          <thead>
            <tr>
              <th>Name of the Supplier</th>
              <th>Bill No.</th>
              <th>Date</th>
              <th>Qty</th>
              <th>Value Rs.</th>
              {invoice?.length > 1 && <th>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {invoice.map((row, index) => (
              <tr key={index}>
                <td>
                  <RB.Form.Control
                    disabled={isDisable}
                    type="text"
                    value={row.supplierName}
                    onChange={(e) =>
                      handleInputChange(index, "supplierName", e.target.value)
                    }
                  />
                </td>
                <td>
                  <RB.Form.Control
                    disabled={isDisable}
                    type="text"
                    value={row.billNo}
                    onChange={(e) =>
                      handleInputChange(index, "billNo", e.target.value)
                    }
                  />
                </td>
                <td>
                  <DatePicker
                    disabled={isDisable}
                    selected={row.date}
                    onChange={(date) => handleInputChange(index, "date", date)}
                    dateFormat="dd-MM-yyyy"
                    className="form-control date-picker-installation"
                    placeholderText="Select Date"
                    popperPlacement="bottom"
                    popperContainer={({ children }) => (
                      <div className="datepicker-portal">{children}</div>
                    )}
                  />
                </td>
                <td>
                  <RB.Form.Control
                    type="text"
                    disabled={isDisable}
                    value={row.qty}
                    onChange={(e) =>
                      handleInputChange(index, "qty", e.target.value)
                    }
                  />
                </td>
                <td>
                  <RB.Form.Control
                    type="text"
                    value={row.value}
                    disabled={isDisable}
                    onChange={(e) =>
                      handleInputChange(index, "value", e.target.value)
                    }
                  />
                </td>
                {invoice?.length > 1 && (
                  <td>
                    <RB.Button
                      className="btn-flat"
                      disabled={isDisable}
                      title="Delete"
                      onClick={() => removeRow(index)}
                    >
                      <Trash />
                    </RB.Button>
                  </td>
                )}
              </tr>
            ))}
            <tr>
              <td colSpan={4}>Total</td>
              <td>
                {invoice.reduce(
                  (total, row) => total + (parseFloat(row.value) || 0),
                  0
                )}
              </td>
            </tr>
          </tbody>
          <RB.Button
            variant="primary"
            className="mt-1"
            size="sm"
            onClick={addRow}
            disabled={isDisable}
          >
            Add Row
          </RB.Button>
        </RB.Table>
      </div>
      <div className="mt-3 table-responsive">
        <h5>SR and Other Document Booking Details</h5>
        <RB.Table bordered>
          <thead>
            <tr>
              <th>No.</th>
              <th>Date</th>
              <th>Item Desc</th>
              <th>Basic</th>
              <th>BED/Adhoc</th>
              <th>IGST</th>
              <th>SGST</th>
              <th>CGST</th>
              <th>Capitalisation Value</th>
              {docBooking?.length > 1 && <th>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {docBooking.map((row, index) => (
              <tr key={index}>
                <td className="p-1">
                  <RB.Form.Control
                    type="text"
                    value={row.no}
                    disabled={isDisable}
                    onChange={(e) =>
                      handleDocInputChange(index, "no", e.target.value)
                    }
                  />
                </td>
                <td className="p-1">
                  <DatePicker
                    selected={row.date}
                    disabled={isDisable}
                    onChange={(date) =>
                      handleDocInputChange(index, "date", date)
                    }
                    dateFormat="dd-MM-yyyy"
                    className="form-control date-picker-installation"
                    placeholderText="Select Date"
                    popperPlacement="bottom"
                    popperContainer={({ children }) => (
                      <div className="datepicker-portal">{children}</div>
                    )}
                  />
                </td>
                <td className="p-1">
                  <RB.Form.Control
                    type="text"
                    disabled={isDisable}
                    value={row.itemDesc}
                    onChange={(e) =>
                      handleDocInputChange(index, "itemDesc", e.target.value)
                    }
                  />
                </td>
                <td className="p-1">
                  <RB.Form.Control
                    type="text"
                    value={row.basic}
                    disabled={isDisable}
                    onChange={(e) =>
                      handleDocInputChange(index, "basic", e.target.value)
                    }
                  />
                </td>
                <td className="p-1">
                  <RB.Form.Control
                    disabled={isDisable}
                    type="text"
                    value={row.bedAdhoc}
                    onChange={(e) =>
                      handleDocInputChange(index, "bedAdhoc", e.target.value)
                    }
                  />
                </td>
                <td className="p-1">
                  <RB.Form.Control
                    type="text"
                    value={row.igst}
                    disabled={isDisable}
                    onChange={(e) =>
                      handleDocInputChange(index, "igst", e.target.value)
                    }
                    className="installation-ceri-input"
                  />
                </td>
                <td className="p-1">
                  <RB.Form.Control
                    type="text"
                    disabled={isDisable}
                    className="installation-ceri-input"
                    value={row.sgst}
                    onChange={(e) =>
                      handleDocInputChange(index, "sgst", e.target.value)
                    }
                  />
                </td>
                <td className="p-1">
                  <RB.Form.Control
                    disabled={isDisable}
                    type="text"
                    className="installation-ceri-input"
                    value={row.cgst}
                    onChange={(e) =>
                      handleDocInputChange(index, "cgst", e.target.value)
                    }
                  />
                </td>
                <td className="p-1">
                  <RB.Form.Control
                    type="text"
                    disabled={isDisable}
                    value={row.capValue}
                    onChange={(e) =>
                      handleDocInputChange(index, "capValue", e.target.value)
                    }
                  />
                </td>
                {docBooking?.length > 1 && (
                  <td>
                    <RB.Button
                      className="btn-flat"
                      title="Delete"
                      onClick={() => removeDocRow(index)}
                    >
                      <Trash />
                    </RB.Button>
                  </td>
                )}
              </tr>
            ))}
            <tr>
              <td colSpan={8}>Total</td>
              <td>
                {docBooking.reduce(
                  (total, row) => total + (parseFloat(row.capValue) || 0),
                  0
                )}
              </td>
            </tr>
          </tbody>
          <RB.Button
            variant="primary"
            className="mt-1"
            size="sm"
            onClick={addDocRow}
            disabled={isDisable}
          >
            Add Row
          </RB.Button>
        </RB.Table>
      </div>
    </>
  );
}

export default DynamicTables;
